module.exports = __webpack_public_path__ + "static/media/ss.5e0bad12.svg";